var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-light"},[_vm._v("Total Sales Supply")]),_c('div',{staticClass:"card-body"},[(_vm.highChartsOptions)?_c('highcharts',{attrs:{"options":_vm.highChartsOptions}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }